import React, { FC, Fragment } from 'react';
import { SelectableItem } from '@src/components/SelectableItem';
import { highLightText } from '@src/containers/Source/utils/highlightText';
import { PlacesSearchDropdownProps } from './props';
import './styles.scss';

export const PlacesSearchDropdown: FC<PlacesSearchDropdownProps> = ({
  setPlace,
  searchValue,
  isLoading,
  isRemote,
  isRelocation,
  onRemoteToggle,
  onRelocationToggle,
  onSelectGlobal,
  locations,
}) => {
  return (
    <div className="source-location-search-dropdown">
      <div className="source-location-search-dropdown__title">Type to search country or city...</div>

      {locations.map(location => {
        return (
          location.entity?.longName && (
            <div
              className="source-location-search-dropdown__option"
              key={location.entity?.id}
              onClick={() => setPlace(location)}
            >
              {highLightText(searchValue, location.entity.longName)}
            </div>
          )
        );
      })}

      {onSelectGlobal && (
        <div className="source-location-search-dropdown__global-select" onClick={onSelectGlobal}>
          View globally
        </div>
      )}

      {isLoading && (
        <Fragment>
          <div className="source-location-search-dropdown__loading-item pulse-fade" />
          <div className="source-location-search-dropdown__loading-item pulse-fade" />
          <div className="source-location-search-dropdown__loading-item pulse-fade" />
        </Fragment>
      )}

      {(onRemoteToggle !== undefined || onRelocationToggle !== undefined) && (
        <>
          <div className="source-location-search-dropdown__divider" />
          <div className="source-location-search-dropdown__title">Location preference</div>
        </>
      )}

      {onRemoteToggle && (
        <SelectableItem
          className="source-location-search-dropdown__check"
          isSelected={isRemote}
          label="Remote"
          onClick={() => onRemoteToggle(!isRemote)}
        />
      )}

      {onRelocationToggle && (
        <SelectableItem
          className="source-location-search-dropdown__check"
          isSelected={isRelocation}
          label="Relocation"
          onClick={() => onRelocationToggle(!isRelocation)}
        />
      )}
    </div>
  );
};
